import { Box, IconButton, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material"
import { MoreVertOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"
import { useRef, useState } from "react"

import { useGoodsReceiptHeaderActions } from "../../hooks"
import type { GoodsReceiptHeaderActionConfig } from "../../types"

import type { GoodsReceipt } from "@/graphql/codegen/graphql"

interface GoodsReceiptDetailsHeaderActionsProps {
  goodsReceipt: GoodsReceipt
  onEdit?: (goodsReceipt: GoodsReceipt) => void
  onDelete?: (goodsReceipt: GoodsReceipt) => void
  onCreatePallets?: () => void
  onUpload?: () => void
  onMarkAsNotReceived?: (goodsReceipt: GoodsReceipt) => void
}

export const GoodsReceiptDetailsHeaderActions: FC<GoodsReceiptDetailsHeaderActionsProps> = ({
  goodsReceipt,
  onEdit,
  onUpload,
  onDelete,
  onMarkAsNotReceived,
  onCreatePallets,
}) => {
  const anchorElRef = useRef<HTMLButtonElement>(null)
  const [isDropdownOpen, setIsDropdownOpen] = useState(false)

  const handleDropdownOpen = () => setIsDropdownOpen(true)
  const handleDropdownClose = () => setIsDropdownOpen(false)

  const actions = useGoodsReceiptHeaderActions({
    goodsReceipt,
    onEdit,
    onUpload,
    onDelete,
    onMarkAsNotReceived,
    onCreatePallets,
    onClose: handleDropdownClose,
  })

  if (!actions.length) {
    return null
  }

  return (
    <Box className='flex items-center justify-center' ref={anchorElRef}>
      <IconButton onClick={handleDropdownOpen} data-test='header-actions-button'>
        <MoreVertOutlined />
      </IconButton>
      <Menu
        anchorEl={anchorElRef.current}
        open={isDropdownOpen}
        onClose={handleDropdownClose}
        data-test='header-actions-menu'
      >
        {actions.map((action: GoodsReceiptHeaderActionConfig) => (
          <MenuItem key={action.testId} data-test={action.testId} onClick={action.handler}>
            <ListItemIcon>{action.icon}</ListItemIcon>
            <ListItemText primary={action.label} />
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}
